(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('httpProgress', ['$window', function ($window) {
            this.post = function (url, data, callbacks) {
                var httpPost = new $window.XMLHttpRequest();

                httpPost.upload.addEventListener('progress', function (e) {
                    if (typeof callbacks.progress === 'function') {
                        callbacks.progress(e);
                    }
                }, false);

                httpPost.upload.addEventListener('load', function (e) {
                    if (typeof callbacks.progress === 'function') {
                        callbacks.progress(e);
                    }
                }, false);

                httpPost.upload.addEventListener('error', function (e) {
                    if (typeof callbacks.error === 'function') {
                        callbacks.error(e);
                    }
                }, false);

                httpPost.upload.addEventListener('abort', function (e) {
                    if (typeof callbacks.error === 'function') {
                        callbacks.error(e);
                    }
                }, false);

                httpPost.onload = function () {
                    if (typeof callbacks.success === 'function') {
                        try {
                            callbacks.success(JSON.parse(httpPost.responseText));
                        } catch (err) {
                            if (typeof callbacks.error === 'function') {
                                callbacks.error(err);
                            }
                        }
                    }
                };

                httpPost.open('post', url, true);
                httpPost.send(data);

                return this;
            };
            return this;
        }]);
}());
